var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24Sort = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M8 4L8 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.5 17.5L8 20l2.5-2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M16 6L16 20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.5 6L16 3.5 13.5 6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24Sort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_sort.a3528f78.svg";
export { ForwardRef as ReactComponent };